import React, { ReactElement } from 'react';

interface Props {
  width?: string;
  height?: string;
}

const ErrorCircleX = (props: Props): ReactElement => {
  const { width, height } = props;

  return (
    <svg width={width} height={height} viewBox="0 0 16 16">
      <path d="M8,0c4.418,0 8,3.582 8,8c0,4.418 -3.582,8 -8,8c-4.418,0 -8,-3.582 -8,-8c0,-4.418 3.582,-8 8,-8Zm0,1.2c-3.756,0 -6.8,3.044 -6.8,6.8c0,3.756 3.044,6.8 6.8,6.8c3.756,0 6.8,-3.044 6.8,-6.8c0,-3.756 -3.044,-6.8 -6.8,-6.8Zm3.153,3.57c0.23,0.227 0.24,0.593 0.027,0.83l-0.017,0.02l-2.307,2.36l2.307,2.36l0.017,0.019c0.214,0.238 0.204,0.604 -0.027,0.83c-0.231,0.225 -0.598,0.227 -0.83,0.008l-0.019,-0.018l-2.287,-2.34l-2.288,2.34c-0.232,0.237 -0.611,0.241 -0.848,0.01c-0.231,-0.226 -0.241,-0.592 -0.027,-0.83l0.017,-0.019l2.307,-2.36l-2.308,-2.36l-0.017,-0.02c-0.214,-0.237 -0.204,-0.603 0.027,-0.83c0.23,-0.225 0.597,-0.226 0.83,-0.007l0.018,0.018l2.288,2.34l2.287,-2.34c0.232,-0.237 0.612,-0.242 0.849,-0.01l0.001,-0.001Z" />
    </svg>
  );
};

ErrorCircleX.defaultProps = {
  width: '100%',
  height: '100%',
};

export default ErrorCircleX;
